import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
import moment from 'dayjs';
var sourceData = [];
var beginDay = new Date().getTime();

for (var i = 0; i < 10; i++) {
  sourceData.push({
    x: moment(new Date(beginDay + 1000 * 60 * 60 * 24 * i)).format('YYYY-MM-DD'),
    y: Math.round(Math.random() * 10)
  });
}

var tooltip = ['x*y', function (x, y) {
  return {
    name: x,
    value: y
  };
}];
var scale = [{
  dataKey: 'x',
  min: 2
}, {
  dataKey: 'y',
  title: '时间',
  min: 1,
  max: 30
}];
export default {
  name: 'MiniBar',
  props: {
    dataSource: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: 200
    }
  },
  created: function created() {
    if (this.dataSource.length === 0) {
      this.data = sourceData;
    } else {
      this.data = this.dataSource;
    }
  },
  data: function data() {
    return {
      tooltip: tooltip,
      data: [],
      scale: scale
    };
  }
};